// extracted by mini-css-extract-plugin
export default {"notice":"DeceasedPatientNotice_notice__TkjlM","icon":"DeceasedPatientNotice_icon__4O4Lv","text":"DeceasedPatientNotice_text__xfxWN"};